import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import ProtectedRoute from './components/common/ProtectedRoute';
import MainLayout from './components/layout/MainLayout';

const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const ProjectListPage = React.lazy(() => import('./pages/ProjectListPage'));
const EditorPage = React.lazy(() => import('./pages/EditorPage'));
const ModelManagementPage = React.lazy(() => import('./pages/admin/ModelManagementPage'));
const UserManagementPage = React.lazy(() => import('./pages/admin/UserManagementPage'));
const GroupManagementPage = React.lazy(() => import('./pages/admin/GroupManagementPage'));
const UsageEstimationPage = React.lazy(() => import('./pages/admin/UsageEstimationPage'));
const PresetProjectPage = React.lazy(() => import('./pages/admin/PresetProjectPage'));
const ResourceRepairPage = React.lazy(() => import('./pages/admin/ResourceRepairPage'));
const WorkflowCanvasBenchmarkPage = import.meta.env.DEV
  ? React.lazy(() => import('./pages/WorkflowCanvasBenchmarkPage'))
  : null;

const Loading: React.FC = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spin size="large" />
  </div>
);

const App: React.FC = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {WorkflowCanvasBenchmarkPage && (
          <Route path="/__workflow-canvas-benchmark" element={<WorkflowCanvasBenchmarkPage />} />
        )}

        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Navigate to="/projects" replace />} />
            <Route path="/projects" element={<ProjectListPage />} />
            <Route path="/admin/models" element={<ModelManagementPage />} />
            <Route path="/admin/presets" element={<PresetProjectPage />} />
            <Route path="/admin/users" element={<UserManagementPage />} />
            <Route path="/admin/groups" element={<GroupManagementPage />} />
            <Route path="/admin/usage" element={<UsageEstimationPage />} />
            <Route path="/admin/resource-repairs" element={<ResourceRepairPage />} />
          </Route>

          <Route path="/projects/:projectId/editor" element={<EditorPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/projects" replace />} />
      </Routes>
    </Suspense>
  );
};

export default App;
